import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import LoginForm from '../components/LoginForm';
import './Home.css';

const APP_STORE_URL = 'https://apps.apple.com/app/id6743340759';

function Home() {
  const { currentUser } = useAuth();
  const [showLogin, setShowLogin] = useState(false);

  return (
    <div className="home">
      <section className="hero">
        <div className="container hero-layout">
          <div className="hero-content">
            <div className="hero-badge">
              <span className="ai-pill">✨ Now with AI shelf scanning</span>
            </div>
            <h1 className="hero-title">
              Your bookshelf,<br />
              <span className="hero-title-accent">brought to life.</span>
            </h1>
            <p className="hero-description">
              ChapterChat is the social reading app that keeps your library, your
              friends, and your next great read in one beautiful place. Snap a photo
              of your shelf, and watch it become a living library.
            </p>
            <div className="hero-actions">
              <a href={APP_STORE_URL} className="btn btn-primary btn-large">
                 Download on the App Store
              </a>
              {currentUser ? (
                <a href="/dashboard" className="btn btn-secondary btn-large">
                  Go to My Books
                </a>
              ) : (
                <button onClick={() => setShowLogin(true)} className="btn btn-secondary btn-large">
                  Sign in on the web
                </button>
              )}
            </div>
            <p className="hero-note">Free to use · iPhone &amp; iPad · Optional Plus subscription</p>
          </div>

          <div className="hero-visual" aria-hidden="true">
            <div className="phone-frame">
              <div className="phone-notch"></div>
              <div className="phone-screen">
                <div className="phone-header">
                  <span className="phone-greeting">Good evening, Reader</span>
                  <span className="phone-streak">🔥 15-day streak</span>
                </div>
                <div className="phone-shelf">
                  <div className="mini-book duo-violet"></div>
                  <div className="mini-book duo-coral"></div>
                  <div className="mini-book duo-green"></div>
                  <div className="mini-book duo-gold"></div>
                  <div className="mini-book duo-blue"></div>
                </div>
                <div className="phone-card">
                  <span className="phone-card-title">Currently reading</span>
                  <div className="phone-progress">
                    <div className="phone-progress-fill"></div>
                  </div>
                  <span className="phone-card-sub">Page 214 of 320</span>
                </div>
                <div className="phone-card phone-card-ai">
                  <span className="phone-card-title">✨ Because you loved sci-fi…</span>
                  <span className="phone-card-sub">3 new picks for you</span>
                </div>
              </div>
            </div>
            <div className="floating-chip chip-club">📖 Book club: 4 new replies</div>
            <div className="floating-chip chip-friend">👋 Maya finished your rec</div>
          </div>
        </div>
      </section>

      <section className="features">
        <div className="container">
          <div className="section-header">
            <h2>Reflects how you actually read</h2>
            <p>Every feature in ChapterChat exists to get you to your next great book.</p>
          </div>
          <div className="features-grid">
            <div className="feature-card card">
              <div className="feature-icon icon-scan">📷</div>
              <h3>Scan your shelf</h3>
              <p>
                Photograph an entire bookshelf and AI identifies every spine, or scan a
                single barcode. Your physical library becomes digital in seconds.
              </p>
            </div>
            <div className="feature-card card">
              <div className="feature-icon icon-ai">✨</div>
              <h3>AI recommendations</h3>
              <p>
                Personalized picks, shelf analysis, and reading insights based on what
                you love — not what an algorithm wants to sell you.
              </p>
            </div>
            <div className="feature-card card">
              <div className="feature-icon icon-club">💬</div>
              <h3>Book clubs</h3>
              <p>
                Join clubs, keep up with discussions, and get AI-generated prompts that
                actually spark conversation.
              </p>
            </div>
            <div className="feature-card card">
              <div className="feature-icon icon-buddy">🤝</div>
              <h3>Buddy reads</h3>
              <p>
                Read the same book with a friend, compare progress, and react to the
                same chapters without spoilers.
              </p>
            </div>
            <div className="feature-card card">
              <div className="feature-icon icon-streak">🔥</div>
              <h3>Streaks &amp; stats</h3>
              <p>
                Log reading sessions, keep your streak alive, and watch your reading
                year take shape in beautiful charts.
              </p>
            </div>
            <div className="feature-card card">
              <div className="feature-icon icon-social">👥</div>
              <h3>Friends &amp; activity</h3>
              <p>
                See what friends are reading, share your shelf on your terms, and swap
                recommendations that land.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="plus">
        <div className="container">
          <div className="plus-card card-featured">
            <div className="plus-copy">
              <span className="plus-badge">ChapterChat Plus</span>
              <h2>Unlimited AI, for readers who want more</h2>
              <p>
                Everyone gets 10 free AI actions each month — shelf scans,
                recommendations, and insights. Plus members get unlimited access,
                billed simply through your Apple&nbsp;ID.
              </p>
            </div>
            <div className="plus-actions">
              <a href={APP_STORE_URL} className="btn btn-accent btn-large">
                Try ChapterChat free
              </a>
              <span className="plus-note">Monthly or yearly · Cancel anytime in the App Store</span>
            </div>
          </div>
        </div>
      </section>

      <section className="cta">
        <div className="container">
          <div className="cta-content">
            <h2>Your next chapter starts here</h2>
            <p>Download ChapterChat and turn your reading life into something worth sharing.</p>
            <a href={APP_STORE_URL} className="btn btn-primary btn-large">
               Download on the App Store
            </a>
          </div>
        </div>
      </section>

      {showLogin && <LoginForm onClose={() => setShowLogin(false)} />}
    </div>
  );
}

export default Home;
